import React, { ReactNode } from "react";
import s from "./app-view-card.module.scss";
import cn from "classnames";

interface IAppViewCardProps {
  label: ReactNode;
  children: ReactNode;
  sharedStyles?: string;
  style?: React.CSSProperties;
}

export const AppViewCard: React.FC<IAppViewCardProps> = ({
  label,
  children,
  sharedStyles,
  style,
}) => {
  return (
    <div className={cn(s.card, sharedStyles)} style={style}>
      <span className={s.card__label}>{label}</span>
      {children}
    </div>
  );
};
